import { Box } from "@mui/material"
import { StyledWaitingNode } from "./WaitingNode.styled"


export const WaitingNode = () => {
    return <StyledWaitingNode>
        <Box className="sliderContainer left">
            <Box className="slider " />
        </Box>
        <Box className="sliderContainer right">
            <Box className="slider " />
        </Box>
    </StyledWaitingNode>
}